import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M2.375 6c0-.345.28-.625.625-.625h18a.625.625 0 1 1 0 1.25H3A.625.625 0 0 1 2.375 6Zm0 6c0-.345.28-.625.625-.625h18a.625.625 0 1 1 0 1.25H3A.625.625 0 0 1 2.375 12Zm0 6c0-.345.28-.625.625-.625h12a.625.625 0 1 1 0 1.25H3A.625.625 0 0 1 2.375 18Z"
    />
  </svg>
`;
